import { Action, SubjectRoles } from "@/api-schema-enums";
import type { AppAbility } from "@/casl-provider";
import type { User } from "@/store/user-store";
import type { AbilityBuilder } from "@casl/ability";

export function setVehicleBuyInPermissions(user: User, builder: AbilityBuilder<AppAbility>) {
  if (user.roles.includes(SubjectRoles.FabVehicleBuyInUser)) {
    builder.can(Action.Create, "VehicleBuyIn");
    builder.can(Action.Read, "VehicleBuyIn");
    builder.can(Action.Update, "VehicleBuyIn");
    builder.can(Action.Manage, "ElectronicSignatureTemplateConfiguration");
  }
}
